import TOGGLE_DARK_MODE from '../constants/darkMode';

export default function toggleDarkMode() {
  return { type: TOGGLE_DARK_MODE };
}
